























import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class ActionSheet extends Vue {
  @Prop({ type: Object, required: false }) private btnObj!: any;
  @Prop({ type: Boolean, required: false }) private isShow!: boolean;
  private screenHight: any;
  private marginTopTips: string = '';
  private mounted() {
     this.screenHight = document.documentElement.clientHeight;
  }

  @Emit('change')
    private changeItem(index: any) {
        return index;
    }

   @Watch('isShow')
    private onChangeValue(val: number, old: any) {
        if (this.isShow) {
        const refelement = ( this.$refs.content as any );
        refelement.style.transform = 'translate3d(0%, ' + this.screenHight + 'px, 0)';
        this.marginTopTips = ( this.screenHight - ( refelement.getBoundingClientRect().height )) + 'px';
        refelement.style.transform = 'translate3d(0%, ' + 0 + ', 0)';
        }
    }
}
